import { render, staticRenderFns } from "./ProducerSelect.vue?vue&type=template&id=2fb2b073&scoped=true&"
import script from "./ProducerSelect.vue?vue&type=script&lang=js&"
export * from "./ProducerSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProducerSelect.vue?vue&type=style&index=0&id=2fb2b073&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2b073",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSelect,VTooltip})
